__webpack_require__.p = "/Ayesha-portfolio/";